import FlightBookSidebar from 'components/Flight/Passengers/Sidebar';
import FlightBookPassengersMain from 'components/Flight/Passengers/main';
import * as S from './flightPassengers.styles';

const FlightBookPassengers = () => {
  return (
    <S.Wrapper>
      <S.Main>
        <FlightBookPassengersMain />
      </S.Main>
      <S.Sidebar>
        <FlightBookSidebar />
      </S.Sidebar>
    </S.Wrapper>
  );
};

export default FlightBookPassengers;
